export default {
  'policy.privacy.title_1':
    '<h3>プライバシーポリシー</h3>' +
    '多肉男子文化推進協会 プライバシー声明および個人情報利用同意条項' +
    '<br />' +
    '最終更新日：2025年8月31日',
  'policy.privacy.title_2':
    '多肉男子文化推進協会（以下「当協会」といいます）は、申請者および会員の個人情報とプライバシー保護を非常に重視しています。お客様の権利を保護し、「個人情報保護法」の関連規定を遵守するため、以下の個人情報の収集・利用・管理方針を説明いたします。',
  'policy.privacy.paragraph_1':
    '<h4>一、個人情報の収集目的</h4>' +
    '当協会は以下の特定目的のためにお客様の個人情報を収集します：' +
    '<ul>' +
    '<li>入会資格審査および会員身分確認</li>' +
    '<li>イベント申込、チケット送付およびイベント通知</li>' +
    '<li>会員専用情報や機能の提供（会員ページログイン、サークル申込、通知送信など）</li>' +
    '<li>イベント安全および会場入場管理</li>' +
    '<li>会員サービスおよびお問い合わせへの対応</li>' +
    '<li>統計分析およびイベント改善の参考（個別データの公開は含まない）</li>' +
    '</ul>',
  'policy.privacy.paragraph_2':
    '<h4>二、収集する個人情報の種類</h4>' +
    '入会申込内容に基づき、当協会は以下の情報を収集する場合があります：' +
    '<ul>' +
    '<li>氏名</li>' +
    '<li>生年月日</li>' +
    '<li>身分証番号</li>' +
    '<li>連絡先（メール、LINE ID、SNSアカウントなど）</li>' +
    '<li>住所</li>' +
    '<li>性別および性的指向（入会条件確認のみに使用、外部公開なし）</li>' +
    '<li>個人の嗜好／サークル活動紹介（イベント審査の参考）</li>' +
    '</ul>',
  'policy.privacy.paragraph_3':
    '<h4>三、個人情報の利用方法および期間</h4>' +
    'お客様の個人情報は当協会により台湾国内で使用され、利用期間は会員存続期間またはイベント管理に必要な期間です。' +
    '<br />' +
    '情報は当協会内部のみで使用され、第三者への無断開示・譲渡・販売・貸与は行いません。' +
    '<br />' +
    '法律で別途規定されている場合、またはお客様の書面同意がある場合を除き、当協会は情報を第三者に提供しません。',
  'policy.privacy.paragraph_4':
    '<h4>四、データ保護措置</h4>' +
    '当協会は適切な技術的・管理的安全対策を講じ、個人情報を不正アクセス、漏洩、改ざん、破損から保護します。',
  'policy.privacy.paragraph_5':
    '<h4>五、お客様の権利</h4>' +
    '「個人情報保護法」第3条に基づき、お客様は当協会に以下の請求を行うことができます：' +
    '<ul>' +
    '<li>個人情報の確認または閲覧請求</li>' +
    '<li>コピーの請求</li>' +
    '<li>追加または訂正の請求（正当な理由が必要）</li>' +
    '<li>収集・処理・利用の停止請求</li>' +
    '<li>削除の請求（会員資格は終了します）</li>' +
    '</ul>' +
    '書面または電子申請にて当協会窓口にご提出ください。合理的な期間内に対応いたします。',
  'policy.privacy.paragraph_6':
    '<h4>六、その他</h4>' +
    '18歳未満の方は当協会に入会できません。' +
    '<br />' +
    '本条項に同意いただけない場合は、会員申込書に記入しないでください。' +
    '<br />' +
    '当協会は法律または業務上の必要に応じて本条項を随時修正する権利を有し、最新バージョンは協会ウェブサイトまたは公式プラットフォームに掲載されます。',
  'policy.usage.title':
    '<h3>会員規約</h3>' +
    '以下の規約をよくお読みになり、理解し同意された上で当協会への入会を申請してください。',
  'policy.usage.paragraph_1':
    '<h4>一、会員資格</h4>' +
    '<ol>' +
    '<li>申請者は18歳以上で完全な法律行為能力を有する男性であること。</li>' +
    '<li>申請者は生物学的男性であり、性的指向が男性であること。</li>' +
    '<li>' +
    '申請者は当協会が推進するGMPD文化の核心価値を十分に理解し、尊重と友好の態度で活動に参加すること。' +
    '</li>' +
    '<li>当協会は入会申請の審査および会員資格の取消権を有し、その理由を外部に説明する義務を負いません。</li>' +
    '</ol>',
  'policy.usage.paragraph_2':
    '<h4>二、会員の義務</h4>' +
    '<ol>' +
    '<li>当協会の規則および各種イベント規定を遵守すること。</li>' +
    '<li>他の会員の性的指向、性格、身体的特徴およびプライバシーを尊重すること。</li>' +
    '<li>イベントの進行およびスタッフの指示に協力し、交流空間の友好と安全を維持すること。</li>' +
    '<li>協会名義で権利侵害、嫌がらせ、詐欺または協会の名誉を毀損する行為を行わないこと。</li>' +
    '<li>会員がコミュニティ規範に違反し、改善が見られない場合、当協会は参加権の停止または会員資格の取消を行うことができます。</li>' +
    '</ol>',
  'policy.usage.paragraph_3':
    '<h4>三、禁止事項</h4>' +
    'コミュニティ品質を維持するため、以下の行為は会員資格停止または終了の対象となります：' +
    '<ul>' +
    '<li>ゲイまたは多様な体型に対する差別、侮辱、排除、攻撃的な発言や行動。</li>' +
    '<li>協会プラットフォームを利用した個人的な嫌がらせ、不適切なナンパ、強制的な言動。</li>' +
    '<li>イベントやコミュニティにおける騒動、分裂、秩序の混乱を引き起こす行為。</li>' +
    '<li>許可なく協会名を用いた商業または非商業活動。</li>' +
    '<li>誤解を招く情報の拡散や他人になりすました入会申請。</li>' +
    '</ul>',
  'policy.usage.paragraph_4':
    '<h4>四、個人情報の利用</h4>' +
    '<ol>' +
    '<li>会員が提供する個人情報は、当協会の内部審査および連絡のみに使用されます。</li>' +
    '<li>当協会は会員個人情報を外部に公開せず、第三者に提供することもありません。</li>' +
    '<li>会員が個人情報の閲覧、修正または削除を希望する場合、自ら申請することができます。</li>' +
    '</ol>',
  'policy.usage.paragraph_5':
    '<h4>五、その他</h4>' +
    '<ol>' +
    '<li>当協会は運営上の必要に応じて本規約を修正し、公式プラットフォームに公告します。個別通知は行いません。</li>' +
    '<li>会員が修正内容に同意しない場合、いつでも会員資格を退会申請することができます。</li>' +
    '<li>本規約の中日文に不一致がある場合は、中国語版を優先とします。</li>' +
    '</ol>',
};
